export default "__VITE_ASSET__BQy4J3Gb__"